import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { LicenseListRow } from 'components';
import './DashboardLicense.css';
import * as commonVar from 'libs/commonVar';
import * as common from 'libs/commonFunc';

const DashboardLicense = (props) => {
  // 국제화 처리
  const { formatMessage } = props.intl;
  const { periodList, timesList, maintainLicense } = props;

  const warningComponent = (
    <div className="license-warning">
      <img src="/img/setting/license-check.png" />
      <div className="warning-text">
        {defineMessages(formatMessage({ id: 'Dashboard_5', defaultMessage: '사용 중인 라이센스가 없습니다.' }))}
      </div>
    </div>
  );

  const maintainInUse = common.nowEpoch() < maintainLicense.licenseEndDate ? true : false;

  return (
    <div className="dashboard-license">
      <div className="license period">
        <div className="license-type-text">
          {defineMessages(formatMessage({ id: 'LicenseEdit_25', defaultMessage: '기간 라이센스' }))}
        </div>
        {periodList.length > 0
          ? <LicenseListRow
            key={periodList[0].licenseNo}
            licenseInfo={periodList[0]}
            existLicenseType="period"
            // existLicenseData={existLicenseData}
            status={periodList[0].status}
            vertical={true}
          />
          : warningComponent
        }
      </div>
      {commonVar.isSaas === 1 ?
        <div className="license times">
          {/* <div className="license-type-text">
            {defineMessages(formatMessage({ id: 'LicenseEdit_26', defaultMessage: '횟수 라이센스' }))}
          </div> */}
          {timesList.length > 0
            ? <div> 
                <div className="license-type-text">
                  {defineMessages(formatMessage({ id: 'LicenseEdit_26', defaultMessage: '횟수 라이센스' }))}
                </div>
                <LicenseListRow
                  key={timesList[0].licenseNo}
                  licenseInfo={timesList[0]}
                  existLicenseType="times"
                  // existLicenseData={existLicenseData}
                  status={timesList[0].status}
                  vertical={true}
                />
              </div>
            : <div />
          }
        </div>
        :
        <div className="license maintenance">
          <div className="license-type-text">
            {defineMessages(formatMessage({ id: 'LicenseEdit_45', defaultMessage: '유지보수 라이센스' }))}
          </div>
          {maintainLicense && maintainInUse ?
            <LicenseListRow
              key={1}
              licenseInfo={{}}
              // existLicenseType="maintain"
              // existLicenseData={existLicenseData}
              maintainLicense={maintainLicense}
              status={1}
              vertical={true}
            />
            : warningComponent
          }
        </div>
      }
    </div>
  )
};

export default injectIntl(DashboardLicense);


// WEBPACK FOOTER //
// ./src/script/components/dashboard/DashboardLicense.js